import { render, staticRenderFns } from "./ArticleTemplate.vue?vue&type=template&id=557ea90c&"
import script from "./ArticleTemplate.vue?vue&type=script&lang=js&"
export * from "./ArticleTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports